<template>
  <div class="home">
    <el-container>
      <el-header class="elheader" height="90px">
        <div class="header">
          <a href="#" title="返回中国传媒大学首页" class="t-logo">
            <img src="../images/logo.png" border="0" />
          </a>
          <span class="el-span">新生网上选床系统</span>
          <div id="rightheader" v-if="username!=null">
            <table>
              <tr><td><el-avatar icon="el-icon-user-solid"></el-avatar></td>
              <td> <span class="el-username">{{username}}</span></td>
              <td><el-button size="mini" class="buttonselect" round  @click="selecthose()" >我要选床</el-button></td>
              <td><el-button size="mini" round @click="Logout()">退出登录</el-button></td>
              </tr>
            </table>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
</template>
<style scoped>
.pwdtypecs{
  display: none;
}
.buttonselect,.buttonselect:hover,.buttonselect:focus{  
  color:#fff;
  text-align:center;
  background-color:#059490;
  border:#059490 1px solid;
}
#rightheader {
  float: right;
  height: 60px;
}
.el-span {
  line-height: 90px;
  font-size: 22px;
  font-weight: bold;
  float: left;
}
.el-button {
  margin: 20px 5px;
}
</style>
<script>
import { defineComponent } from "vue";
import Route from "../router/index";
import { ElMessage } from "element-plus";
import { selecthose } from "../http/api.ts";

export default defineComponent({
  name: "ShopHeader",
  components: {},
  setup() {
    let username = localStorage.getItem("username");   
    return { username };
  },
  methods: {
    Logout() {
      ElMessage.success({message:"退出登录成功！",offset: 300});
      localStorage.removeItem("userToken");
      localStorage.removeItem("username");
      setTimeout(function () {
        Route.push("/");
      }, 1000);
    },selecthose(){
      var url = window.location.href;
      if(url.indexOf("update") >= 0 ){
        ElMessage.error({message:'请先修改密码后再进行选床！',offset: 300});
        return false;
      }
      const loading = this.$loading({
            lock: true,
            text: "跳转中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          selecthose().then((res) => {
            if (res.code == 200) {
              Route.push('read?tmsite='+Math.random());
            }else{
              ElMessage.success({message:"已经选过床位了，请查看学生住宿信息确认表！",offset: 300});
              Route.push('view?tmsite='+Math.random());
            }        
            loading.close();
          });
    }
  },
});
</script>
<style scoped>
.elheader {
  background: url("../images/bg-body.jpg") repeat center center;
}
.header {
  max-width: 1180px;
  margin: 0 auto;
  clear: both;
  padding: 0px 50px;
}
.t-logo {
  float: left;
  margin: 13px 18px 0 0;
}
</style>

